import {HTTP} from '@/services/HttpServices';
import {DynamicForm, DynamicFormSummary, DynamicFormType, DynamicFormTypeId} from '@/support-forms/supportFormModel';
import {CancelToken} from 'axios';

const ROOT_URL = '/admin/dynamic-forms';

export function getDynamicFormTypes(): Promise<DynamicFormType[]> {
    return HTTP.get('/dynamic-form-types?deep=true');
}

export function getDynamicFormSummaries(searchRequest?: any, cancelToken?: CancelToken): Promise<DynamicFormSummary[]> {
    return HTTP.post(ROOT_URL + '/search', searchRequest, {cancelToken});
}

export function getDynamicFormDetails(id: number | string): Promise<DynamicForm> {
    return HTTP.get(ROOT_URL + '/' + id);
}

export function markSupportFormComplete(id: number, isComplete: boolean): Promise<void> {
    return HTTP.put(`${ROOT_URL}/${id}`, { isComplete });
}
